import { render, staticRenderFns } from "./OrderAwaiting.vue?vue&type=template&id=e32d35b4&"
import script from "./OrderAwaiting.vue?vue&type=script&lang=js&"
export * from "./OrderAwaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports